<div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-default" [translate]="'ESQUECEU_SENHA'"></h6>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="emailForm" *ngIf="!enviado">
            <div class="row">
                <div class="col-12">
                    <span>{{'MSG_REDEFINIR_SENHA' | translate}}</span>
                    <div class="form-group mt-2">
                        <label [translate]="'EMAIL'"></label>
                        <input type="text" class="form-control" formControlName="email"
                        [ngClass]="{'required': verificaRequerido('email')}">
                    </div>
                </div>
            </div>
        </form>
        <div class="row" *ngIf="enviado">
            <div class="col-12">
                <span>{{'MSG_SOLICITACAO_ENVIADA' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="modal-footer" *ngIf="!enviado">
        <button type="button" class="btn btn-success badge-pill" (click)="onSubmit()" [disabled]="emailForm.invalid">
          <span [translate]="'REDEFINIR_SENHA'"></span>
        </button>
    </div>
</div>